import { styled } from "@mui/material";
import clsx from "clsx";

const ContainerStyled = styled("div")({
  padding: "16px 12px",
});

const CardSectionContent = ({ children, className }) => (
  <ContainerStyled className={clsx("card-content", className)}>
    {children}
  </ContainerStyled>
);

export default CardSectionContent;
